import { render, staticRenderFns } from "./StaticCount.vue?vue&type=template&id=25bdac65&scoped=true"
import script from "./StaticCount.vue?vue&type=script&lang=js"
export * from "./StaticCount.vue?vue&type=script&lang=js"
import style0 from "./StaticCount.vue?vue&type=style&index=0&id=25bdac65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bdac65",
  null
  
)

export default component.exports